import React from "react";
import { useNavigate } from "react-router-dom";



const Category = ({ category }) => {
  const { name, icon, category:bikeName } = category;

  const navigate = useNavigate();

  const handleNavigate= () =>{
    navigate(`/bikes/${bikeName}`)
}

  return (
    <div onClick={()=>handleNavigate()} className="card bg-base-100 shadow-xl">
      <div className="card-body">
        <img className="p-5 w-52 h-36 mx-auto"  src={icon} alt="" />
        <h2 className="text-2xl font-semibold text-center">{name}</h2>
      </div>
    </div>
  );
};

export default Category;
